import { combineReducers } from 'redux'


import stageReducer from './stage'


export default combineReducers( {
    stage: stageReducer
} )



// WEBPACK FOOTER //
// ./src/reducers/index.js